module.exports = __webpack_public_path__ + "img/wlcs-plugin.91c6ed0.png";